export const hasFlag = (mask: number | undefined, flag: number) =>
  Boolean(mask && (mask & flag) === flag)
